import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actionTypes from './../../store/actions/helpAction';
import fetchHelpAction from './../../store/actions/fetch/fetchHelpAction';
import HelpModal from './../../components/Help/HelpModal'

class Help extends Component {

  componentDidMount() {
    this.watchForClose();
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, ready, setModalContent, content, open} = this.props;
    closeModal = this.props.closeModal;

    if (pending || !ready || !content) return null;

    if (open){
      return (
        <HelpModal
          open={open}
          content={content}
          handleCloseModal={handleCloseModal}
          data={data} />
      )
    } else {
      return null;
    }
  }

  watchForClose() {
    document.addEventListener("keydown", (event) => {
      if (event.keyCode === 27){
        handleCloseModal();
      }
    }, false);
  }
}

let closeModal;

const handleCloseModal = () => {
  const modals = document.getElementsByClassName("ReactModal__Overlay");

  [].forEach.call(modals, function (element) {
    element.classList.add("nppe2-fc-help-modal__closing")
  });

  setTimeout( () => {
    closeModal();
  }, 250);
}

const mapStateToProps = state => {
  return {
    error: state.helpReducer.error,
    data: state.helpReducer.data,
    pending: state.helpReducer.pending,
    ready: state.helpReducer.ready,
    content: state.helpReducer.content,
    open: state.helpReducer.open,
    closeModal: state.helpReducer.closeModal,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchHelpAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    closeModal: () => dispatch({
      type: actionTypes.CLOSE_MODAL,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Help);
